module.exports = __webpack_public_path__ + "static/assets/img/blur-bg-kiosk.23b819a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blur-bg-kiosk.jpg
// module id = O6YC
// module chunks = 3